/** @jsx jsx */

import { jsx } from "@emotion/react";
import { useNavigate } from "@gatsbyjs/reach-router";
import { Loading } from "@whitespace/gatsby-theme-smorgasbord/src/components";
import { useUserContext } from "@whitespace/gatsby-theme-smorgasbord/src/hooks";
import { useAsync } from "@whitespace/gatsby-theme-smorgasbord/src/utils";
import PropTypes from "prop-types";
import { useState } from "react";
// import { useTranslation } from "react-i18next";

import { useCGIGRP2 } from "../hooks";

import CGIGRP2LoginDialogError from "./CGIGRP2LoginDialogError";
import CGIGRP2LoginDialogProgress from "./CGIGRP2LoginDialogProgress";

// import * as styles from "./CGIGRP2LoginDialog.module.css";

CGIGRP2LoginDialogSame.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
};

export default function CGIGRP2LoginDialogSame() {
  // const { t } = useTranslation();
  const navigate = useNavigate();
  let [attempt, setAttempt] = useState(0);
  const { login } = useUserContext();
  const { response, loading, error } = useCGIGRP2(
    "/login",
    { method: "post", body: "{}" },
    [attempt],
  );
  const { del } = useCGIGRP2();
  const finalizeLogin = useCGIGRP2("/login");

  let { value: finalizeLoginData } = useAsync(
    async () => await finalizeLogin.response?.json?.(),
    [finalizeLogin.loading, finalizeLogin.error],
  );

  if (loading || finalizeLogin.loading || finalizeLogin.response.ok) {
    return <Loading />;
  }

  if (finalizeLogin.error) {
    return (
      <CGIGRP2LoginDialogError
        error={finalizeLoginData?.code}
        onRetryClick={() => navigate("/")}
      />
    );
  }

  if (response.ok) {
    return (
      <CGIGRP2LoginDialogProgress
        mode="same"
        // key={attempt}
        onRetry={() => setAttempt((attempt) => attempt + 1)}
        onAbort={async () => {
          navigate("/");
          await del("/login");
        }}
        onSuccess={async () => {
          await finalizeLogin.put({
            headers: { "Content-Type": "application/json", body: "{}" },
          });
          login();
        }}
      />
    );
  }

  return (
    <CGIGRP2LoginDialogError
      error={error?.code}
      onRetryClick={() => navigate("/")}
    />
  );
}
